export default {"src":"/_next/static/media/toggle_minus.83a04b81.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};